export const templates = [
	{
		id: '1',
		title: 'When all child work items are resolved, then resolve parent',
	},
	{
		id: '2',
		title: 'When any child work item transitions to In Progress, then set the parent work item to In Progress',
	},
	{
		id: '3',
		title: 'When any child work item transitions to In Progress, set the parent work item to In Progress, unless the parent is resolved'
	},
	{
		id: '4',
		title: 'When parent is resolved, then resolve all child work items',
	},
	{
		id: '5',
		title: 'When the parent’s Iteration is updated, apply the change to all child work items'
	},
	{
		id: '6',
		title: 'When the parent’s Priority changes is updated, apply the change to all child work items'
	},
	{
		id: '7',
		title: 'When child is created copy area path and iteration from parent'
	}
];